import { takeEvery, call, put } from "redux-saga/effects";
import { generic } from "utils/action";
import { authorizedRequest, HTTP_METHODS } from "utils/request";
import * as CONSTANTS from "./constants";

// Individual exports for testing
export function* getPaginationResults({ pagination, limit, offset, callback }) {
  try {
    const method = HTTP_METHODS.POST;

    const params = {};

    if (limit !== undefined) {
      params.limit = limit;
    }

    if (offset !== undefined) {
      params.offset = offset;
    }

    const paginatedResult = yield call(
      authorizedRequest,
      CONSTANTS.PAGINATION_URL(),
      {
        method,
        body: pagination,
        params,
      },
    );

    yield put(
      generic(CONSTANTS.GET_PAGINATION_RESULTS_SUCCESS_ACTION, {
        result: paginatedResult,
      }),
    );
    yield call(callback);
  } catch (e) {
    yield put(
      generic(CONSTANTS.GET_PAGINATION_RESULTS_FAILED_ACTION, {
        reason: e.response.data,
      }),
    );
  }
}

export default function* PatientOverviewPageSaga() {
  // See example in containers/HomePage/saga.js
  yield takeEvery(
    CONSTANTS.GET_PAGINATION_RESULTS_ACTION,
    getPaginationResults,
  );
}
